(function() {
    'use strict';

    angular
        .module('app.layout')
        .directive('sellers', sellers);

    /* @ngInject */
    function sellers() {
        var directive = {
            bindToController: true,
            templateUrl: 'sellers.tpl',
            controller: sellersController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                data: '='
            }
        };
        return directive;

        function link(scope, element, attrs) {
        }

    }

    /* @ngInject */
    function sellersController () {
    }
})();